module.exports = __webpack_public_path__ + "static/media/installApp.34590885.svg";